import React from 'react';
import clsx from 'clsx';

const statusColors = {
  successful: 'bg-green-500 text-white',
  failed: 'bg-red-500/10 text-red-400',
  pending: 'bg-yellow-500 text-black',
  initiated: 'bg-yellow-500 text-black',
};

export const StatusBadge = ({ status = '' }) => {
  const normalizedStatus = status.toLowerCase();
  const badgeClass = statusColors[normalizedStatus] || 'bg-white/10 text-white';

  return (
    <div
      className={clsx(
        'px-2 py-0.5 text-[10px] font-semibold uppercase rounded-full',
        badgeClass
      )}
    >
      {status}
    </div>
  );
};
